import React from "react";
import styled from "@emotion/styled";
import { PaginationButton } from "../../pagination-button";

const PaginationWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 0.625rem;
  width: calc(100% - 1.25rem);
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 100;
  transform: translateY(-50%);
  pointer-events: none;
`;

export interface LayoutPaginationProps {
  onPrev?: () => void;
  onNext?: () => void;
  allowPrev?: boolean;
  allowNext?: boolean;
  hidePrev?: boolean;
  hideNext?: boolean;
}

const LayoutPagination = ({
  onPrev,
  onNext,
  allowPrev = true,
  allowNext = true,
  hidePrev = false,
  hideNext = false,
}: LayoutPaginationProps): JSX.Element => {
  return (
    <PaginationWrapper>
      {!hidePrev && <PaginationButton left onClick={onPrev} disabled={!allowPrev} />}
      {!hideNext && <PaginationButton right onClick={onNext} disabled={!allowNext} />}
    </PaginationWrapper>
  );
};

export default LayoutPagination;
